import _ from 'lodash';

export class FormValidation {

  validateValues = [];

  addValidation(value) {
    this.validateValues.push(value)
  }

  validate() {
    let errors = []

    _.forEach(this.validateValues, (validate) => {
      if (validate.validate().isError()) {
        errors.push(validate.validate())
      }
    })

    let isValid = errors.length <= 0 ? true : false

    if (isValid)
      return isValid
    else
      throw new FormValidationError(
        _.first(errors)?.message, errors, isValid
      );
  }
}

class Validation {

  constructor(value, fieldName) {
    this.value = value;
    this.fieldName = fieldName;
    this.validationError = new ValidationError(value, fieldName);
  }

  isRequired() {
    if (_.isNil(this.value) || this.value.length <= 0) {
      this.validationError.addError("is_required")
    }
    return this;
  }

  maxChar(size = 2024) {
    if (this.value?.length > size) {
      this.validationError.addError("max_character_exceeded")
    }
    return this
  }

  minChar(size = 12) {
    if (this.value?.length < size) {
      this.validationError.addError("min_character_not_met")
    }
    return this
  }

  isDigit() {
    if(!(/^\d+$/i.test(this.value))) {
      this.validationError.addError("digit_not_met")
    }
    return this
  }

  matchRegex(regex) {
    return this
  }

  validate() {
    return this.validationError
  }
}

class ValidationError {

  message = "";
  errors = [];

  constructor(value, fieldName) {
    this.value = value;
    this.fieldName = fieldName;
  }

  addError(message) {
    this.errors.push(message);
    if (this.errors.length === 1) {
      //Only first message gets kept as quick access error
      this.message = message;
    }
  }

  isError() {
    return this.errors.length > 0;
  }
}

class FormValidationError extends Error {
  constructor(message, errors, isValid) {
    super(message);
    this.name = "FormValidationError";
    this.errors = errors;
    this.isValid = isValid
  }
}

export default Validation